import {
    ApolloClient,
    InMemoryCache,
    ApolloLink,
    HttpLink,
} from '@apollo/client';
import fetch from 'node-fetch';
import {pathName} from '../NotificationConfig';

function authMiddleware(funnelLocation, duaid) {
    return new ApolloLink((operation, forward) => {
        operation.setContext(({headers = {}}) => ({
            headers: {
                ...headers,
                'Client-Info': funnelLocation,
                'Device-User-Agent-ID': duaid,
            },
        }));
        return forward(operation);
    });
}

function getHttpLink(page) {
    return new HttpLink({
        uri: `${pathName[page]}/graphql/loom`,
        fetch,
    });
}

function createApolloClient(funnelLocation, duaid) {
    let authMiddle = authMiddleware(funnelLocation, duaid);
    return new ApolloClient({
        cache: new InMemoryCache(),
        link: authMiddle.concat(getHttpLink(funnelLocation)),
    });
}

export {createApolloClient};
